module.exports = __webpack_public_path__ + "img/hero-mobile_jp.f33e992.jpg";